import { FONT } from "@/styles/common";
import { Box, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomBox = styled(Box)``;

export const CustomRoom = {
    Name: styled(Text)`
        ${FONT("pretendard", 20, 700)}
    `,
    Description: styled(Text)`
        ${FONT("pretendard", 16, 300)}
        overflow: hidden;
        width: 480px;
        text-overflow: ellipsis;
        white-space: nowrap;

        @media (min-width: ${({ theme }) => theme.MEDIA.laptop}) {
            width: auto;
            white-space: normal;
        }

        @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
            width: auto;
            white-space: normal;
        }
    `,
};

interface CustomDiscountProps {
    discountRate: number;
}

export const CustomDiscount = styled(Text)<CustomDiscountProps>`
    color: ${({ discountRate }) =>
        discountRate !== 0 ? ({ theme }) => theme.COLOR.white : ({ theme }) => theme.COLOR.black};
    background: ${({ discountRate }) =>
        discountRate !== 0 ? ({ theme }) => theme.COLOR.black : ({ theme }) => theme.COLOR.white};
    border: ${({ discountRate }) => (discountRate !== 0 ? "none" : "1px solid")};
`;
